import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../services/app-settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from '../services/application.service';
import { platformSettings } from 'src/app/models/platformSettings';
import { UserService } from '../services/user.service';
import { User } from 'src/app/models/user';
import { userPrivilege } from 'src/app/models/userPrivilege';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent {

  appToken: string;
  deploymentID: any;
  assureLoginUrl = AppSettingsService.appSettings.AssureAPIUrl;
  platformSettings: platformSettings = JSON.parse(sessionStorage.getItem('settings'));
  
  constructor(private route: ActivatedRoute, 
              private router: Router,
              private applicationService: ApplicationService, 
              ) {
      sessionStorage.setItem('platformName', 'apidevelopersite');
      this.appToken = this.route.snapshot.queryParamMap.get('tkn');
      console.log(this.appToken)
      if (this.route.params) {
        this.route.params.subscribe(params => {
          if (params && params['Platform']) {
            sessionStorage.setItem('platformName', params['Platform']);
          }
        });
      }
      if (this.appToken != null) {
        sessionStorage.setItem('token', this.appToken);
        this.applicationService.ValidateAndGetAccessToken().then(() => {
          this.applicationService.login().catch(() => {
            this.redirect();
          });      
        }).catch(() => {
          this.redirect();
        });
      } else {
        this.redirect();
      }
      console.log(this.appToken)
      this.router.navigate(['/']);
     }

     public redirect(){
      sessionStorage.clear();
      this.router.navigate(['/']);
    }

    ngOnInit(){
    this.router.navigate(['/']);
    }
}
